import { PiTrash } from 'react-icons/pi'
import { Button } from '@firstbite/ui'

/**
 * A low-emphasis destructive action — a neutral (gray) icon-only ghost button
 * that turns red on hover. For de-emphasized deletes in expanded timeline
 * records (notes, reminders) on the entity detail pages, where the row's primary
 * "Edit" stays the labeled action and the trash stays quiet until intended.
 * Shared by the deal + contact detail pages so both delete affordances match.
 */
export function DeleteIconButton({
  label,
  disabled,
  onClick,
}: {
  label: string
  disabled?: boolean
  onClick: () => void
}) {
  return (
    <Button
      variant="neutral"
      iconOnly
      size="sm"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
      // Neutral gray by default (variant="neutral"); reveal the destructive red
      // only on hover. `!` beats the variant's own gray hover tokens.
      className="hover:!bg-error-bg-subtle hover:!text-error-strong"
    >
      <PiTrash aria-hidden="true" />
    </Button>
  )
}
